import React, { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ResetPasswordPage() {
  const [email, setEmail] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (newPassword.length < 6) { setError("Password must be at least 6 characters"); return; }
    if (newPassword !== confirmPassword) { setError("Passwords don't match"); return; }
    setLoading(true);
    try {
      await axios.post(`${API}/auth/reset-password`, { email, new_password: newPassword });
      setSuccess(true);
    } catch (e) {
      const detail = e.response?.data?.detail;
      setError(typeof detail === "string" ? detail : "Something went wrong. Please try again.");
    }
    setLoading(false);
  };

  if (success) {
    return (
      <div className="min-h-screen flex items-center justify-center px-6" style={{ background: '#F7F5F0' }}>
        <div className="w-full max-w-md text-center">
          <Link to="/" className="block text-center mb-10">
            <span className="text-2xl" style={{ fontFamily: 'Cormorant Garamond, serif', color: '#2D3A31' }}>sober-curious.com</span>
          </Link>
          <div className="earthy-card" data-testid="reset-success">
            <h1 className="text-3xl mb-4" style={{ fontFamily: 'Cormorant Garamond, serif', color: '#2D3A31' }}>Password Updated</h1>
            <p className="text-sm mb-6" style={{ color: '#5B665E' }}>Your password has been reset. You can now log in with your new password.</p>
            <Link to="/login" className="earthy-btn earthy-btn-primary text-base inline-block" data-testid="go-login-btn">Go to Login</Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center px-6" style={{ background: '#F7F5F0' }}>
      <div className="w-full max-w-md">
        <Link to="/" className="block text-center mb-10" data-testid="reset-logo-link">
          <span className="text-2xl" style={{ fontFamily: 'Cormorant Garamond, serif', color: '#2D3A31' }}>sober-curious.com</span>
        </Link>
        <div className="earthy-card">
          <h1 className="text-3xl mb-2" style={{ fontFamily: 'Cormorant Garamond, serif', color: '#2D3A31' }}>Reset Your Password</h1>
          <p className="text-sm mb-8" style={{ color: '#5B665E' }}>Enter your email and choose a new password.</p>
          {error && (
            <div className="mb-4 p-3 rounded-md text-sm" style={{ background: 'rgba(150,69,69,0.08)', color: '#964545', border: '1px solid rgba(150,69,69,0.2)' }} data-testid="reset-error">
              {error}
            </div>
          )}
          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <label className="block text-sm font-medium mb-1.5" style={{ color: '#5B665E' }}>Email</label>
              <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="earthy-input" placeholder="you@email.com" required data-testid="reset-email-input" />
            </div>
            <div>
              <label className="block text-sm font-medium mb-1.5" style={{ color: '#5B665E' }}>New Password</label>
              <input type="password" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} className="earthy-input" placeholder="Min 6 characters" required data-testid="reset-password-input" />
            </div>
            <div>
              <label className="block text-sm font-medium mb-1.5" style={{ color: '#5B665E' }}>Confirm New Password</label>
              <input type="password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} className="earthy-input" placeholder="Confirm your new password" required data-testid="reset-confirm-input" />
            </div>
            <button type="submit" disabled={loading} className="earthy-btn earthy-btn-primary w-full text-base" data-testid="reset-submit-btn">
              {loading ? "Resetting..." : "Reset Password"}
            </button>
          </form>
          <p className="text-center mt-8 text-sm" style={{ color: '#5B665E' }}>
            Remember your password? <Link to="/login" className="font-medium underline" style={{ color: '#4A5D4E' }} data-testid="reset-login-link">Log in</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
